// extracted by mini-css-extract-plugin
module.exports = {"root":"_10iHX","label":"_3ugBa","list":"_1Nf32","item":"_113nX","optionList":"_3IK09","validIcon":"_3NrWA","additionalText":"_2d9b6"};